(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('cssWidthBasedOnParent', cssWidthBasedOnParent);

    function cssWidthBasedOnParent(lodash, $timeout, $window) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                angular.element($window).bind('resize', function() {
                    resizeIt();
                });

                resizeIt();

                function resizeIt() {
                    $timeout(function () {
                        var $elem = $(elem);
                        var parentWidth = parseInt($elem.parent().css('width'));
                        $elem.css('width', (parentWidth - 20) + 'px');
                    }, 1000);
                }
            },
        };
    }
})();